var map = {
	"../pages/comunicacion/comunicacion.module": [
		821,
		2
	],
	"../pages/comunicaciones/comunicaciones.module": [
		819,
		1
	],
	"../pages/nueva-comunicacion/nueva-comunicacion.module": [
		820,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 301;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 301
// module chunks = 3